import { render, staticRenderFns } from "./VxInputGroup.vue?vue&type=template&id=08a9e1ec&functional=true&"
import script from "./VxInputGroup.vue?vue&type=script&lang=ts&"
export * from "./VxInputGroup.vue?vue&type=script&lang=ts&"
import style0 from "./VxInputGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports